import api from "../../api.js";

export async function submitBmiBenefitCheck(payload) {
  const res = await api.post("/api/medikredit/benefitcheck/bmi", payload);
  return res.data;
}

export async function submitBmiClaim(payload) {
  const res = await api.post("/api/medikredit/claim/bmi", payload);
  return res.data;
}
